import axios from "axios";
import { getCookie } from "../helpers/common";
import { addErrorLog } from "../Logger/logger";
import { toast } from "react-toastify";
import { getEnv } from "helpers/environment";

const makeRequest = async (data, contentType) => {
	const accessToken = getCookie("accessToken");

	try {
		const response = await axios({
			method: "post",
			url: getEnv("UTILITY_SERVICE"),
			maxBodyLength: Infinity,
			data: data,
			headers: {
				"Content-Type": contentType || "application/json",
				"Apollo-Require-Preflight": true,
				Authorization: "Bearer " + accessToken,
				withCredentials: true
			}
		});

		return response?.data?.data;
	} catch (error) {
		if (error.response) {
			toast.error(
				"Oops! Something went wrong on our end. We're working to fix it."
			);

			return {
				error: error.message
			};
		}
	}
};

export const encode = async (toencrypt) => {
	const data = JSON.stringify({
		query: `mutation Encrypt($toencrypt: String!) {
			encrypt(toencrypt: $toencrypt) {
				isSuccessful
				message
				resultObject
			}
		}`,
		variables: {
			toencrypt
		}
	});
	let result;

	try {
		result = await makeRequest(data);

		if (result.error) {
			addErrorLog("Encode", result.error);
		}

		return result?.encrypt?.resultObject;
	} catch (error) {
		addErrorLog("Encode", result.error);
		return null;
	}
};

export const decode = async (todecrypt) => {
	const data = JSON.stringify({
		query: `mutation Decrypt($todecrypt: String!) {
			decrypt(todecrypt: $todecrypt) {
				isSuccessful
				message
				resultObject
			}
		}`,
		variables: {
			todecrypt
		}
	});

	let result;

	try {
		result = await makeRequest(data);

		if (result.error) {
			addErrorLog("Decode", result.error);
		}

		return result?.decrypt?.resultObject;
	} catch (error) {
		addErrorLog("Decode", result.error);
		return null;
	}
};

export const minifyFiles = async (data) => {
	try {
		const result = await makeRequest(data, "multipart/form-data");
		return result?.minifiedfiles?.resultObject;
	} catch (error) {
		addErrorLog("error", error);
		return null;
	}
};

export const testConnection = async (input) => {
	const data = JSON.stringify({
		query: `mutation TestConnection($input: ConfigInput!) {
      testConnection(input: $input) {
        statusCode
        body
      }
    }`,
		variables: input
	});
	try {
		const result = await makeRequest(data);
		return result?.testConnection;
	} catch (error) {
		addErrorLog("mutation TestConnection", error);
		return null;
	}
};

export const testQuery = async (input) => {
	const data = JSON.stringify({
		query: `mutation ExecuteQuery($sqlStatement: String!, $input: ConfigInput) {
      executeQuery(sql_statement: $sqlStatement, input: $input) {
        statusCode
        body
      }
    }`,
		variables: input
	});
	try {
		const result = await makeRequest(data);
		return result?.executeQuery;
	} catch (error) {
		addErrorLog("mutation ExecuteQuery", error);
		return null;
	}
};
